<template>
  <ul class="steps" :class="step">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StepperElement',
  props: {
    step: {
      type: String,
      required: true,
    },
  },
});

</script>

<style lang="scss">
    .steps{
        padding: 0;
        margin: var(--space-0);
        list-style-type: none;
        display: flex;
        li{
           width: 12px;
           height: 12px;
           background: transparent;
           border: 1px solid var(--accent-100);
           margin-right: 5px;
           border-radius: $br-circle;
        }
        &.step-{
            &1{
                li:nth-child(1){
                  background: var(--accent-100);
                }
            }
            &2{
                li:nth-child(1){
                    background: var(--accent-100);
                }
                li:nth-child(2){
                  background: var(--accent-100);
                }
            }
            &3{
                li:nth-child(1){
                    background: var(--accent-100);
                }
                li:nth-child(2){
                  background: var(--accent-100);
                }
                li:nth-child(3){
                  background: var(--accent-100);
                }
            }
            &4{
                li:nth-child(1){
                    background: var(--accent-100);
                }
                li:nth-child(2){
                  background: var(--accent-100);
                }
                li:nth-child(3){
                  background: var(--accent-100);
                }
                li:nth-child(4){
                  background: var(--accent-100);
                }
            }
        }
    }
</style>
